import { window, document } from "global";
import React from "react";
import { render, hydrate } from "react-dom";
import { I18nextProvider } from "react-i18next";
import { loadableReady } from "@loadable/component";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import App from "./components/App";
import TagManager from "react-gtm-module";
import globalReactN, { setClientReactNState } from "lib/reactn-init";
import { createI18nextInstance } from "lib/i18next-init";
import { ReactTableDefaults } from "react-table-6";
import NoTableData from "components/NoTableData";
import { initJSONFetcher } from "@outplayed/json-fetcher";
import { initApolloClient } from "api/graphql/apolloInit";
import "lib/local-moment";
import ReactGA from "react-ga4";
import { UGGLegacyRouteAdapter } from "@ugitgud/legos/context/routing";
import { UggGAEventProvider } from "@ugitgud/legos/components/util/UggGAEventProvider";
import { ByteBrewProvider } from "@ugitgud/legos/context/bytebrew";
import { getSetAnonId } from "lib/analyticsHelper";
import { BannerProvider } from "@ugitgud/legos/components/banner/BannerContainer";

getSetAnonId();

// styling
import "react-tabs/style/react-tabs.css";
// import "material-components-web/dist/material-components-web.min.css";
import "react-table-6/react-table.css";
import "stylesheets/app.scss";

import moment from "moment";
moment.locale("en");

if (process.env.NODE_ENV === "development") {
  const whyDidYouRender = require("@welldone-software/why-did-you-render");
  whyDidYouRender(React);
}

ReactGA.initialize(process.env.REACT_APP_GA_ID);

// See U.GG Permissions Plan
if (window) {
  // Do not run GA if on overwolf pages (prevent double page views)
  if (document.getElementById("overwolf")) {
    console.log("ignore ga tracking on overwolf pages");
  }
  // If set, we check the permission.
  else if (localStorage.getItem("UGG_HAS_SET_CONSENT_STORAGE_STORAGE_KEY_V5") === "set") {
    const permissions = JSON.parse(localStorage.getItem("UGG_PERMISSIONS_STORAGE_KEY_V5"));

    if (permissions["5"] || Object.keys(permissions).length === 0) {
      if (!window.dataLayer) {
        console.log("GA4 is running");
      }
    }
  } else {
    console.log("GA4 is running");
  }
}

// Change default for 'no rows' in react-table-6
Object.assign(ReactTableDefaults, {
  NoDataComponent: NoTableData,
});

// Initialize reactn global state
const preloadedReactNState = Object.assign({}, window.__REACTN_PRELOADED_STATE__, window.__SSR_DATA__);
// console.log(preloadedReactNState);
const ReactNProvider = globalReactN;
ReactNProvider.setGlobal(preloadedReactNState);
setClientReactNState(ReactNProvider);
delete window.__REACTN_PRELOADED_STATE__;
delete window.__SSR_DATA__;

initJSONFetcher(ReactNProvider);

// console.log("Global", ReactNProvider.getGlobal())
// setGlobal(preloadedReactNState);

const client = initApolloClient(ReactNProvider.getGlobal().authToken, window.__APOLLO_STATE__);

// Add <meta charset="UTF-8"> to the top of header
// for Lighthouse best practices to work
if (document) {
  var head = document.getElementsByTagName("head")[0];
  var meta = document.createElement("meta");
  meta.setAttribute("charset", "UTF-8");
  head.insertBefore(meta, head.firstChild);
}

if (window) {
  if (localStorage.getItem("firstTimeUser") === null) {
    localStorage.setItem("firstTimeUser", "true");
  } else if (localStorage.getItem("firstTimeUser") === "true") {
    localStorage.setItem("firstTimeUser", "false");
  }
}

// Browser Auto Refresh
if (process.env.NODE_ENV === "development") {
  const ws = new WebSocket("ws://localhost:8080?client=web");

  ws.onerror = () => {
    console.log("browser-reload ws not running");
  };

  ws.onopen = () => {
    console.log("connection");
  };
  ws.onmessage = (e) => {
    if (e.data === "reload") {
      window.location.reload();
    }
  };
}

const startHydrate = async () => {
  // initializeFB();
  const curLang = ReactNProvider.getGlobal().language;
  const i18nextInstance = await createI18nextInstance(curLang);

  loadableReady(() => {
    hydrate(
      <HelmetProvider>
        <I18nextProvider i18n={i18nextInstance}>
          <ReactNProvider>
            <BrowserRouter>
              <ByteBrewProvider appVersion={"1.0.0"} appId={process.env.BYTEBREW_GAME_ID} appKey={process.env.BYTEBREW_SDK_KEY}>
                <UGGLegacyRouteAdapter>
                  <BannerProvider>
                    {/*<ZeusRouteResponder shouldChangeForRoute={(current,previous) => (current.pathname !== previous.pathname)}/>*/}
                    <UggGAEventProvider defaultGame="wow" />
                    <App client={client} />
                  </BannerProvider>
                </UGGLegacyRouteAdapter>
              </ByteBrewProvider>
            </BrowserRouter>
          </ReactNProvider>
        </I18nextProvider>
      </HelmetProvider>,
      document.getElementById("root"),
    );
  });
};

if (window) {
  window.onload = () => {
    setTimeout(() => {
      if (document) {
        const scripts = [
          // "https://www.gstatic.com/firebasejs/7.19.1/firebase-app.js",
          // "https://www.gstatic.com/firebasejs/7.19.1/firebase-messaging.js"
        ];
        for (let i = 0; i < scripts.length; i++) {
          let script = document.createElement("script");
          script.src = scripts[i];
          script.async = true;
          document.getElementsByTagName("body")[0].appendChild(script);

          // if (i === scripts.length-1) {
          //   script.onload = () => {
          //     initializeFB();
          //   }
          // }
        }
      }
    }, 1);
  };
}

window && sessionStorage.setItem("initial_page", window.location.pathname);
startHydrate();
